<template>
    <aside :show.sync="show" placement="right" header="修改团队人数" :width="450">
    <form>
      <h4 class="text-center">【{{trip.catalog}}】{{trip.heading}}</h4>

      <div class="form-group">
        <label class="control-label">团队人数</label>
        <input type="text" class="form-control" v-model="form.size">
      </div>
      <div class="form-group">
        <label for="f2" class="control-label">招募管理</label>
        <div class="alert alert-warning">
          角色人数必须大于已报名人数
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>角色</th>
              <th>人数</th>
              <th>已报名</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in form.need" track-by="$index">
              <td>{{item.role}}</td>
              <td>
                <input type="number" class="form-control" v-model="item.size">
              </td>
              <td>
                {{item.leaderSize}}
              </td>
              <td>
                <a href="javascript:void(0)" class="btn btn-danger" @click="form.need.$remove(item)" v-show="!item.id">&times;</button>
              </td>
            </tr>
          </tbody>
        </table>
        <label class="control-label">新的招募</label>
        <div class="row">
          <div class="col-xs-9">
            <select class="form-control" v-model="selectRole">
              <option :value="null">-</option>
              <option v-for="item in roles" track-by="$index" :value="item">{{item.role}}</option>
            </select>
          </div>
          <div class="col-xs-3">
            <a href="javascript:void(0)" class="btn btn-primary btn-block" @click="add(selectRole)">添加</a>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label">抢单备注</label>
        <textarea id="" cols="30" rows="3" class="form-control" v-model="leaderTips"></textarea>
      </div>

      <div class="form-group">
        <label for="f2" class="control-label">发送消息</label>
        <div>
          <label class="radio-inline">
            <input type="radio" v-model="messageLevel" :value="5">立即发送
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="messageLevel" :value="0">稍后发送
          </label>
        </div>
      </div>
      <div class="from-group text-center">
        <button class="btn btn-primary" type="button" @click="click(submit)($event)">提交</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import { aside } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import _ from 'lodash'

  let roles = [
    {
      role: '领队',
      size: ''
    },
    {
      role: 'ST志愿者',
      size: ''
    },
    {
      role: '督导',
      size: ''
    },
    {
      role: '试走',
      size: ''
    },
    {
      role: '考官',
      size: ''
    },
    {
      role: 'CE大活动志愿者',
      size: ''
    }
  ]

  export default {
    components: {
      aside
    },
    props: {
      trip: {
        required: true,
        type: Object
      },
      show: {
        required: true,
        twoWay: true
      }
    },
    data () {
      return {
        tripStatus: config.tripStatus,
        roles,
        selectRole: '',
        leaderTips: '',
        messageLevel: 0,
        form: {
          size: null,
          need: []
        }
      }
    },
    methods: {
      add (role) {
        if (!role) {
          return
        }
        if (_.find(this.form.need, ['role', role.role])) {
          window.alert('已经添加过此角色')
          return
        }
        this.form.need.push(_.cloneDeep(role))
      },
      submit () {
        let need = this.form.need.map((item) => {
          item.leaderTips = this.leaderTips || ''
          item.messageLevel = this.messageLevel
          return _.pick(item, [
            'id',
            'role',
            'size',
            'leaderTips',
            'messageLevel'
          ])
        })
        let data = Object.assign({}, this.form, {
          need
        })
        return this.$http.put(`${config.apiWe}/product/trip/${this.trip.id}`, data)
          .then(() => {
            this.show = false
            this.$dispatch('callback')
          })
      },
      getNeed () {
        return this.$http.get(`${config.apiWe}/product/trip/${this.trip.id}/leaderInfo`)
          .then(({data}) => {
            this.form.need = data.need
            if (data.need.length) {
              this.leaderTips = data.need[0].remark
            } else {
              this.leaderTips = null
            }
          })
      },
      click: utils.click
    },
    watch: {
      show (val) {
        if (!val) {
          return
        }
        this.form.size = this.trip.size
        this.getNeed()
      }
    }
  }
</script>

<style scoped>
  .l-inline {
    display: inline-block;
    width: 4em;
  }
  table td {
    vertical-align: middle !important;
  }
</style>



/** WEBPACK FOOTER **
 ** EditSize.vue?fe0c6fb6
 **/